import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { ThemeProvider } from '@mui/material/styles';
import { GlobalTheme } from '../../theme';
import Box from '@mui/material/Box';
import { Button, Link } from '@mui/material';
import TravelRequest from '../navbar/travelRequest';

export default function MantleDisplay() {
    const [animate, setAnimate] = useState(false);

    const { banner_for, refer_other_id } = useParams();
    const navigate = useNavigate();
    const [mantleData, setMantleData] = useState([]);


    const [isLoading, setIsLoading] = useState(true);

    // Fetch Mantle Data and Keywords
    useEffect(() => {
        const fetchMantleData = async () => {
            try {
                const response = await fetch('https://aaryanholidays.in/frontend/homeBanner');
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setMantleData(data);
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching mantle data: ', error);
            }
        };

        fetchMantleData();
    }, [banner_for, refer_other_id]);

    useEffect(() => {
        // Trigger animation once the component mounts
        const timeout = setTimeout(() => {
            setAnimate(true);
        }, 0); // Delay can be adjusted as needed
        return () => clearTimeout(timeout); // Cleanup
    }, []);


    return (
        <React.Fragment>
            <ThemeProvider theme={GlobalTheme}>
                <CssBaseline />
                {/* {isLoading ? (
                    <>
                        <Box position='absolute' width='100%' height='100%' sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: 4 }}>
                            <Skeleton variant="rectangular" animation='wave' width={200} sx={{ height: 20, mb: 3 }} />
                            <Skeleton variant="rectangular" animation='wave' width={500} sx={{ height: 10, mb: 1 }} />
                            <Skeleton variant="rectangular" animation='wave' width={400} sx={{ height: 10, mb: 1 }} />
                            <Skeleton variant="rectangular" animation='wave' width={200} sx={{ height: 10, mb: 1 }} />

                            <Skeleton variant="rectangular" animation='wave' width={600} sx={{ height: 65, mt: 5, mb: 1, borderRadius: 2 }} />
                        </Box>

                        <Skeleton variant="rectangular" animation='wave' width='100%' height={833} sx={{ height: 20, mb: 3 }} />

                    </>
                ) : (
                    <>

                    </>
                )} */}

                {mantleData.map((item, index) => (
                    <Card component='section' id="headerContainer" key={index} elevation={0} sx={{
                        borderRadius: 0, width: '100%', position: 'relative', zIndex: 1,
                        height: {
                            xs: 490,
                            lg: 833
                        },
                    }}>
                        <Container fixed sx={{
                            position: {
                                xs: 'relative',
                                md: 'absolute'
                            },
                            height: '100%',
                            width: '100%',
                            left: 0, right: 0, bottom: 0, top: 0,
                            zIndex: 2
                        }}>
                            <Grid key={index}>
                                <CardContent id={`mantleText${index}`}
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        margin: '0 auto',
                                        justifyContent: 'center',
                                        textAlign: 'center',
                                        width: {
                                            md: '70%'
                                        },
                                        flexDirection: { lg: 'column' },
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignContent: 'center',
                                        pt: { md: 15.25 }
                                    }}>
                                    <Box>
                                        <Typography id={`mantleHeading${index}`} gutterBottom variant='h1' color='white' className={animate ? 'animate__animated animate__fadeInUp animate__delay-1s' : ''}>{item.heading}</Typography>
                                        <Typography id={`mantleSubHeading${index}`} component='p' variant="subtitle1" color='white'
                                            className={animate ? 'animate__animated animate__fadeIn animate__delay-2s' : ''}
                                            sx={{
                                                mb: 3,
                                                px: '5%'
                                            }}
                                        >
                                            {item.sub_heading}
                                        </Typography>
                                    </Box>
                                    <Stack direction={{ sm: 'column', md: 'row' }} width='100%' spacing={5} justifyContent='center' className={animate ? 'animate__animated animate__fadeInUp animate__delay-3s' : ''}
                                        sx={{
                                            px: { xs: 5, md: 0 }
                                        }}
                                    >
                                        <Link href='/search/ExploreMore' sx={{
                                            backgroundColor: GlobalTheme.palette.primary.main,
                                            textDecoration: 'none',
                                            color: GlobalTheme.palette.common.white,
                                            boxShadow: 'none',
                                            mb: 2, textTransform: 'uppercase',
                                            py: 1.5, px: 5, alignItems: 'center', display: 'flex', justifyContent: 'center',
                                        }}  >Explore More</Link>

                                        <TravelRequest size='medium' btnLabel='Travel Request' variant='outlined' sx={{
                                            color: GlobalTheme.palette.common.white,
                                            borderColor: GlobalTheme.palette.common.white,

                                            py: 1.5,
                                        }}

                                            sxOverrides={{
                                                backgroundColor: 'transparent',
                                                borderColor: GlobalTheme.palette.common.white,
                                                "&:hover, &:focus": {
                                                    backgroundColor: GlobalTheme.palette.common.black,
                                                    color: GlobalTheme.palette.common.white,
                                                    borderColor: GlobalTheme.palette.common.white,
                                                },
                                            }} />
                                    </Stack>

                                </CardContent>
                            </Grid>
                        </Container>
                        <Grid
                            id="mask"
                            position='absolute'
                            sx={{
                                background: 'linear-gradient(0deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.3) 100%)',
                                zIndex: 1,
                            }}
                            width='100%'
                            height='100%'
                        // className={animate ? 'animate__animated animate__fadeInDown' : ''}
                        />
                        {item.type === 'video' ? (
                            <CardMedia
                                id={`mantle${index}`}
                                key={index}
                                component="video"
                                autoPlay
                                loop
                                muted
                                playsInline
                                sx={{
                                    position: 'absolute',
                                    transform: 'translateX(-50%) translateY(-50%)',
                                    minWidth: '100%',
                                    minHeight: '100%',
                                    height: 'auto',
                                    objectFit: 'cover',
                                    top: {
                                        xs: '50%',
                                    },
                                    left: {
                                        xs: '50%',
                                    },
                                }}>
                                <source src={`https://aaryanholidays.in/express/uploads/${item.src}`} type="video/mp4" />
                                <Typography variant='subtitle2' component='p' color='white'>
                                    {item.sub_heading}
                                </Typography>
                            </CardMedia>
                        ) : (
                            <CardMedia
                                id={`mantle${index}`}
                                key={index}
                                component="img"
                                sx={{
                                    position: 'absolute',
                                    transform: 'translateX(-50%) translateY(-50%)',
                                    minWidth: '100%',
                                    minHeight: '100%',
                                    height: 'auto',
                                    objectFit: 'cover',
                                    top: {
                                        xs: '50%',
                                    },
                                    left: {
                                        xs: '50%',
                                    },
                                }}
                                src={`https://aaryanholidays.in/express/uploads/${item.src}`}
                                alt={item.heading}
                                loading='lazy'
                            />
                        )}
                    </Card>
                ))}
            </ThemeProvider>
        </React.Fragment>
    );
}
